import { CookiebotConsentState } from '@external/cmp-cookiebot';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { RudderStackCookieCategory, rudderStackCookieCategories } from '@ocx-app/lib/rudderStack/rudderStack.types';

import { CookieConsentProviderState } from '../../cookie-consent.types';

export const mapCookiebotStateToCookieConsentProviderState = (
  cookiebotState: CookiebotConsentState,
): CookieConsentProviderState => {
  const rudderStackCookieCategoriesAllowed: RudderStackCookieCategory[] = [rudderStackCookieCategories.necessary];
  const rudderStackCookieCategoriesDenied: RudderStackCookieCategory[] = [];

  // We consider necessary cookies as always allowed, as they are essential for the website to function and cannot be declined by the user.
  // Therefore, we don't push 'c0001' to the denied even though SDK might expect it, because it would not reflect the actual user choice and could lead to confusion in the consent management logic.
  // if (cookiebotState.consent.necessary) rudderStackCookieCategoriesAllowed.push(rudderStackCookieCategories.necessary);
  // else rudderStackCookieCategoriesDenied.push(rudderStackCookieCategories.necessary);

  if (cookiebotState.consent.preferences) {
    rudderStackCookieCategoriesAllowed.push(rudderStackCookieCategories.preferences);
  } else {
    rudderStackCookieCategoriesDenied.push(rudderStackCookieCategories.preferences);
  }

  if (cookiebotState.consent.statistics) {
    rudderStackCookieCategoriesAllowed.push(rudderStackCookieCategories.analytics);
  } else {
    rudderStackCookieCategoriesDenied.push(rudderStackCookieCategories.analytics);
  }

  if (cookiebotState.consent.marketing) {
    rudderStackCookieCategoriesAllowed.push(rudderStackCookieCategories.marketing);
  } else {
    rudderStackCookieCategoriesDenied.push(rudderStackCookieCategories.marketing);
  }

  return {
    consent: {
      necessary: cookiebotState.consent.necessary,
      preferences: cookiebotState.consent.preferences,
      statistics: cookiebotState.consent.statistics,
      marketing: cookiebotState.consent.marketing,
    },
    isConsentGiven: cookiebotState.consented,
    isConsentDeclined: cookiebotState.declined,
    hasConsentResponse: cookiebotState.hasResponse,

    rudderStackCookieCategoriesAllowed,
    rudderStackCookieCategoriesDenied,
  };
};
